import { getCurrentUserId } from '../utils';
import { withCurrentParams } from 'actions/utils';
import { BROADCAST_START_STREAMS } from 'actions/Types';
import { STREAM_STATE_TOGGLE } from 'store/eventConstants';

export default endpoints => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const { user } = getState();
      const action = {
        type: BROADCAST_START_STREAMS,
        request: async apiClient => {
          const response = await apiClient.broadcast.startStreams(
            teamId,
            eventId,
            broadcastId,
            {
              endpoints
            }
          );
          // notify other directors
          socket.emit(STREAM_STATE_TOGGLE, {
            broadcastId,
            notifyingDirector: getCurrentUserId(user)
          });
          return response;
        }
      };

      dispatch(action);
    }
  );
};
